<template>
  <Modal :id="'cmp_bookings_booking_add_artist'" @cancelled="onCancelClick">
    <template slot="header">
      <template> {{ $t("account_shipping_costs") }} </template>
    </template>
    <template slot="body">
      <TextField
        class="m1"
        :id="'shipping_costs'"
        v-bind="textFieldConfig"
        :disabled="!shippingData"
        :value="
          shippingData &&
          shippingData.order &&
          shippingData.order.shipping_costs
        "
        :placeholder="$dft.capHead($t('shipping_costs'))"
        @valuechanged="onTextFieldValueChange"
      ></TextField>
      <Dropdown
        class="m2"
        :disabled="!shippingData"
        :options="royaltyAccountsTV"
        :selected="royaltyAccountsTV.find((e) => e.value == royalty_account_id)"
        :placeholder="$t('royalty_account')"
        box
        deselect
        @selectedChange="(e) => onRoyaltyAccountChange(e)"
      />
    </template>
    <template slot="options">
      <button
        class="dt-button s7 v1 ut-font-small ut-mx-10px"
        v-if="royalty_account_id"
        @click="onRoyaltyAccountClick"
        :disabled="invoiceLoading"
        :class="{
          disabled: invoiceLoading,
        }"
      >
        {{ $t("royalty_account") }}
      </button>
      <button
        class="dt-button s7 v1 ut-mx-10px"
        :disabled="invoiceLoading"
        :class="{
          disabled: invoiceLoading,
        }"
        @click="onInvoiceClick"
      >
      {{ $t('invoice') }}
      </button>
      <button class="dt-button s7 ut-ml-10px" @click="onCancelClick">
        {{$t('cancel')}}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "../../../../dt-plugins/modal/modal";

import { DTIconButton } from "../../../../plugins/button/button";
import NTable from "../../../../plugins/datatable/datatable";

import InputField from "@plugins/text-field/input-field";

import ModalContainer from "@dtplugins/modal/modal-container";
import { format } from "date-fns";
import { OrderService } from "../../services/order.service";
// import { invoiceListLDTRoutes } from "../../../accounting/router/routes";
import { showError } from "../../../../dt-plugins/notification/notification.service";
import { routeWithFrom } from "../../../../utility/route";
import { createTV } from "../../../../models/text-value.model";

export default {
  components: {
    Modal,
    NTable,
    InputField,
    DTIconButton,
    ModalContainer,

    //AdvanceSearch,
  },
  mounted: async function () {
    const shippingStatus = await OrderService.order_shipping_status(
      this.$route.params.order_id
    ).then((res) => {
      return res.data;
    });

    if (shippingStatus?.order?.status != "open") {
      this.$emit("cancelled", true);
    }

    this.shippingData = await OrderService.account_shipping_costs_modal(
      this.$route.params.order_id
    );

    console.log("this.shippingData", this.shippingData, this.royaltyAccountsTV);
  },
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        immediateValidation: false,
      },
      accounted_date: format(new Date(), "YYYY-MM-DD"),

      shippingData: null,
      royalty_account_id: null,
      shipping_costs: null,

      invoiceLoading: false,
      royaltyAccountLoading: false,
    };
  },
  mixins: [],

  computed: {
    royaltyAccountsTV() {
      return createTV(
        this.shippingData?.royalty_accounts,
        "royalty_account_name",
        "royalty_account_id"
      );
    },
  },
  methods: {
    onCancelClick: function () {
      this.$emit("cancelled", true);
    },

    onTextFieldValueChange: function (name, value) {
      this.shipping_costs = value;
    },
    onRoyaltyAccountChange(e) {
      this.royalty_account_id = e.value;
      console.log(this.royalty_account_id);
    },
    async onInvoiceClick() {
      this.invoiceLoading = true;
      const invoiceData = await OrderService.shipping_costs_invoice(
        this.$route.params.order_id,
        this.shipping_costs
      );

      this.$emit("invoiced", invoiceData);
    },
    async onRoyaltyAccountClick() {
      this.invoiceLoading = true;
      const scraData = await OrderService.shipping_costs_royalty_account(
        this.$route.params.order_id,
        this.shipping_costs,
        this.royalty_account_id
      );
      if (scraData.success == 1 ) {
        this.$emit("shipping_costs_royalty_account", scraData);
      } else {
        this.onCancelClick();
      }

    }
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-catalog-releases-releases_list {
  .dt-page--body {
    --offset: 190px;
  }
  td.file_name a {
  }
  .dt-page--data-table {
    --offset: 135px;
  }
  .dt-page--top-bar {
    .input-field-container {
      max-width: 128px;
    }
  }
  // .invoicelist-footer {
  //   border-top: 1px solid var(--sprt-5);

  //   .invoice_status_list {
  //     display: flex;
  //     .status {
  //       margin-top: 15px;
  //       display: flex;
  //       // max-width: 150px;
  //       flex: 0.5;
  //       .circle {
  //         width: 15px;
  //         height: 15px;

  //         margin-right: 10px;
  //         margin-top: 2.5px;
  //       }
  //       .status-name {
  //         flex: 1;
  //       }
  //     }
  //   }
  // }
}
</style>